<template>
    <div class="form-horizontal" v-if="!!user">
        <h1>Ons Referral Programma</h1>
        <program></program>
        <hr />
        <h2>Referral Links</h2>
        <div class="form-group">
            <label for="referralCode" class="col-form-label">Unieke Referral Code:</label>
            <input class="form-control" id="referralCode" name="referralCode" v-model="user.referralCode" readonly  /> 
        </div>
        <div class="form-group">
            <label for="referralProfessional" class="col-form-label">Referral Link Beveiliger:</label>
            <input class="form-control" id="referralProfessional" name="referralProfessional" v-model="referralProfessionalLink" readonly @click="copyProfessionalLink" /> 
        </div>
        <div class="form-goup text-right">                
            <button class="btn btn-outline-azure mr-1" @click="copyProfessionalLink" title="Kopieren"><font-awesome-icon :icon="['far', 'copy']"></font-awesome-icon></button>
            <a :href="'https://twitter.com/intent/tweet?text=Registreer%20je%20nu%20als%20beveiliger%20op%20Azurity%20via:%20&url=' + referralProfessionalLink + '&hashtags=beveiliger,beveiliging,azurity,security,flex&via=Azurity3'" class="btn btn-outline-azure mr-1" target="_blank">Tweet</a>                   
            <a :href="'mailto:?subject=Ik wil je graag uitnodigen om te registeren op Azurity.nl&body=Gebruik%20deze%20link%3A%20' + referralProfessionalLink" role="button" class="btn btn-azure-dark">Link Emailen</a>
        </div>
        <div class="form-group">
            <label for="referralClient" class="col-form-label">Referral Link Opdrachtgever:</label>
            <input class="form-control" id="referralClient" name="referralClient" v-model="referralClientLink" readonly @click="copyClientLink" /> 
        </div>
        <div class="form-goup text-right">
            <button class="btn btn-outline-azure mr-1" @click="copyClientLink" title="Kopieren"><font-awesome-icon :icon="['far', 'copy']"></font-awesome-icon></button>
            <a :href="'https://twitter.com/intent/tweet?text=Registreer%20je%20nu%20als%20opdrachtgever%20op%20Azurity%20via:%20&url=' + referralClientLink + '&hashtags=beveiliger,beveiliging,azurity,security,flex,beveiligersgezocht&via=Azurity3'" class="btn btn-outline-azure mr-1" target="_blank">Tweet</a>                
            <a :href="'mailto:?subject=Ik wil je graag uitnodigen om te registeren op Azurity.nl&body=Gebruik%20deze%20link%3A%20' + referralClientLink" role="button" class="btn btn-azure-dark">Link Emailen</a>
        </div>
        <hr />
        <conditions></conditions>
    </div>
</template>

<script>
import Program from '@/components/Referral/Program';
import Conditions from '@/components/Referral/Conditions';
export default {
    props: ['user'],
    components: {
        'conditions': Conditions,
        'program': Program
    },
    methods: {
        copyProfessionalLink() {
            let copyText = document.getElementById("referralProfessional");
            copyText.select();
            document.execCommand("copy");
            alert("Link gekopieerd: " + copyText.value);
        },
        copyClientLink() {
            let copyText = document.getElementById("referralClient");
            copyText.select();
            document.execCommand("copy");
            alert("Link gekopieerd: " + copyText.value);
        }
    },
    computed: {
        profile() {
            if(this.user)
                return this.user.clientProfile;
            return {};
        },
        referralProfessionalLink() {
            if(this.user)
                return 'https://azurity.nl/security/account/register/professional?referral=' + this.user.referralCode;
            return 'https://azurity.nl/security/account/register/professional';
        },
        referralClientLink() {
            if(this.user)
                return 'https://azurity.nl/security/account/register/client?referral=' + this.user.referralCode;
            return 'https://azurity.nl/security/account/register/client';
        }
    }
}
</script>

<style scoped>
.img-profile {
    width: 75%;
    height: 75%;
}
</style>

